import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'operadorpipe'
})
export class OperadorPipe implements PipeTransform {

  transform(value: any[], args?: any): any {
    if(args == ""){
      return value;
    }
    return value.filter(item => (item.nombre.indexOf(args) !== -1 || item.paterno.indexOf(args) !== -1 ||  item.materno.indexOf(args) !== -1));
  }

}
